import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 16px;
`

export const SwitchWrapper = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid #d9d9d9;
  button {
    float: right;
  }
`

export const SwitchTitle = styled.div`
  color: #363636;
  font-size: 14px;
  font-weight: 500;
`

export const SwitchSubtitle = styled.div`
  color: #757575;
  font-size: 14px;
  margin-top: 4px;
`
